import React from 'react';
import styled from 'styled-components';
import graveStone from '../assets/images/graveStone.jpeg';

const AboutNyrundum = (): JSX.Element => {
  return (
    <AboutNyrundumWrapper>
      <AboutImage>
        <Image src={graveStone} />
      </AboutImage>
      <AboutText>
        <TextWrapper>
          <HeaderText>Berättelsen om Nyurundum</HeaderText>
          <NormalText>
            Vi blickar tillbaka till tiden då Ljungan var seglingsbar och mötte havet långt högre uppströms. Då stora skepp lade till efter omvälvande resor,
            eller gav sig ut på nya. En tid för tusen år sedan då handeln i Njurunda, eller Nyurundum, var omfattande. Varor byttes, såldes eller skeppades
            vidare. Många talar. Många talar om dem som vikingar, som havens krigare. Men inte vi. Vi ser dem som handelsmän och entreprenörer. Entreprenörer
            som levde, arbetade och tillsammans skapade den handelsplats som satte Nyurundum på dåtidens karta. Entreprenörer som vågade ta tillvara på
            möjligheterna och efterlämnade en ort för framtiden. Idag har landet rest sig och havsnivån sakta sjunkit men andan lever stark än idag. Fornminnen
            i landskapet ger eko och påminner oss. Tryggheten i de svarta tjärnarnas djupa vatten, kraften från älven och strävan efter nya utsikter förenar oss
            med våra förfäder. Samma vatten som då utgjorde livsådran och banade färdväg vilar nu stilla i våra produkter. I Nyurundum.
          </NormalText>
        </TextWrapper>
      </AboutText>
    </AboutNyrundumWrapper>
  );
};

const AboutNyrundumWrapper = styled.div`
  background-color: #617060;
  display: grid;
  grid-template-rows: auto auto;
  justify-content: center;

  @media (min-width: 769px) {
    grid-template-columns: 50vw 50vw;
    grid-template-rows: auto;
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
`;

const AboutImage = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;

  @media (min-width: 769px) {
    justify-content: right;
  }
`;

const Image = styled.img`
  width: 100vw;
  max-width: 25rem;

  @media (min-width: 769px) {
    width: 40rem;
    height: 40rem;
    max-width: 90%;
  }
`;

const AboutText = styled.div`
  display: flex;
  justify-content: center;
  max-width: 25rem;

  @media (min-width: 769px) {
    align-items: center;
    justify-content: left;
    width: 100%;
    max-width: 90%;
  }
`;

const TextWrapper = styled.div`
  background-color: #bf7b23;
  align-content: center;
  justify-content: center;
  color: white;
  width: 100vw;

  @media (min-width: 769px) {
  }
`;

const NormalText = styled.div`
  font-size: 1rem;
  line-height: 1.875rem;
  padding-left: 2rem;
  padding-right: 2rem;
  padding-bottom: 2rem;
`;

const HeaderText = styled(NormalText)`
  padding-top: 2rem;
  height: fit-content;
  font-size: 2.625rem;
`;

export default AboutNyrundum;
